import { ContactInfo } from './ContactInfo';
import { File } from './File';
import { Image } from '../Image';
import { MemberGetMember } from './MemberGetMember';
import { RentBuggy } from './RentBuggy';
import { Table } from './Table';
import { Vimeo } from './Vimeo';
import { Youtube } from './Youtube';

export const availableEditorComponentsSplitView = {
  ContactInfo,
  File,
  Image,
  MemberGetMember,
  RentBuggy,
  Table,
  Vimeo,
  Youtube,
};
